import { render, staticRenderFns } from "./search-menu.vue?vue&type=template&id=4239e8cb&scoped=true"
import script from "./search-menu.vue?vue&type=script&lang=ts"
export * from "./search-menu.vue?vue&type=script&lang=ts"
import style0 from "./search-menu.vue?vue&type=style&index=0&id=4239e8cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239e8cb",
  null
  
)

export default component.exports